import { Component, EventEmitter, Input, NO_ERRORS_SCHEMA, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { StoreListComponent } from 'src/app/modals/store-list/store-list.component';
import { Store } from 'src/app/models/contest';
import { Ad } from 'src/app/models/mall';
import { register } from 'swiper/element/bundle';
import { SwiperOptions } from 'swiper/types';

register();

@Component({
  selector: 'app-advertising',
  templateUrl: './advertising.component.html',
  styleUrls: ['./advertising.component.scss'],
})
export class AdvertisingComponent implements OnInit {
  @Input() contestStores: Array<Store> = [];
  @Input() banner: any;

  swiperConfig: SwiperOptions = {
    slidesPerView: 1, // Mostrar una imagen a la vez
    spaceBetween: 10, // Espacio entre las imágenes
    navigation: true, // Habilita las flechas de navegación
    pagination: { clickable: true }, // Habilita la paginación
    loop: true, // Activa el loop (carrusel continuo)
    autoplay: {
      delay: 3000, // Cambia cada 3 segundos
      disableOnInteraction: false, // No detener autoplay en interacción manual
    },
  };

  @Output() goToUpdateData = new EventEmitter<void>();
  @Output() goToBack = new EventEmitter<void>();

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
  }

  get currentAd() {
    if (this.banner.length == 0) return null;
    return this.banner.banners[0];
  }

  async openStoresModal() {
    console.debug('AdvertisingComponent.seeStores()');
    const modal = await this.modalCtrl.create({
      component: StoreListComponent,
      componentProps: {
        contestStores: this.contestStores,
      },
    });
    await modal.present();
  }

  onUpdateDataClick() {
    this.goToUpdateData.emit();
  }

  onGoBackClick() {
    this.goToBack.emit();
  }
}
